import React from 'react';
import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import { CustomThemeProvider, Prompt, usePortal } from 'sonata-react-components';

type Props = {
  id: string;
  onClosePrompt: () => void;
  onDeleteAdvertiserLogo: () => void;
  showPrompt: boolean;
};

const AdvertiserLogoPrompt: React.FC<Props> = ({ id, onClosePrompt, onDeleteAdvertiserLogo, showPrompt }) => {
  const { formatMessage } = useIntl();
  const targetBodyPrompt = usePortal('advertiserLogo_deletePrompt');

  const onDeleteButtonPrompt = () => {
    onDeleteAdvertiserLogo();
    onClosePrompt();
  };
  const promptButton = [
    {
      id: `prompt_button_${id}`,
      onClick: onDeleteButtonPrompt,
      shape: 'squareRounded',
      text: formatMessage({
        defaultMessage: 'Delete logo',
        id: 'advertiserCampaignSelector.uploadLogoAdvertiser.promptButton'
      }),
      type: 'primary'
    }
  ];

  if (!showPrompt) {
    return null;
  }

  return ReactDOM.createPortal(
    <CustomThemeProvider themeContrast="light">
      <Prompt
        buttons={promptButton}
        closePrompt={onClosePrompt}
        icon="fas fa-exclamation-triangle"
        title={formatMessage({
          defaultMessage: "Are you sure you want to delete the advertiser's logo?",
          id: 'advertiserCampaignSelector.uploadLogoAdvertiser.titlePrompt'
        })}
      />
    </CustomThemeProvider>,
    targetBodyPrompt
  );
};

export default AdvertiserLogoPrompt;
